import React from "react";

const PropertiesSection = () => {
  return (
    <section
      style={{
        position: "relative", // To position overlay correctly
        height: "500px", // Adjust height as needed
        backgroundImage:
          "url('	https://websitedemos.net/real-estate-02/wp-content/uploads/sites/430/2019/04/bg-04-free-img.jpg')", // Background image
        backgroundSize: "cover", // Ensures image covers entire section
        backgroundPosition: "center", // Centers the image
      }}
    >
      {/* Overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(34, 139, 34, 0.6)", // Semi-transparent overlay
        }}
      ></div>

      {/* Content */}
      <div
        style={{
          position: "relative",
          zIndex: 1, // Ensures content appears above overlay
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          color: "#fff", // White text
          fontSize: "3rem", // Large heading size
          fontWeight: "bold",
        }}
      >
        Who We Are
      </div>
    </section>
  );
};

export default PropertiesSection;
